import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorSection } from 'react-anchor-navigation';
import './PageTracking.scss';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import InputPhone from '../../components/Input/InputPhone';
import { GetDeliveryService, ValidationFormTracking } from './functions';
import { ServiceData } from '../../redux/services/ServiceRedux';
import ErrorText from '../../components/ErrorText/ErrorText';
import { ITracking } from '../../redux/services/Interfaces';
import { EnumUrlsPages } from '../../services/Enum';
import { NoFoundServerText, StubTrackingInfo } from './constants';
import Table from '../../components/Table/Table';
import moment from 'moment';
import './PageTracking-media.scss';
import FormContainer from '../../components/FormContainer/FormContainer';
import { ValidationFormItems } from '../../services/GlobalFunctions';
import Textarea from '../../components/Textarea/Textarea';
import Content from '../../components/Content/Content';
import Title from '../../components/Title/Title';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Props } from './interfaces';

const PageTracking = ({
  pageName = 'Отслеживание',
  blockedSend,
  blockedSendLoaded,
  recaptchaV2ref,
  contactForms
}: Props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const [numberUrl, phoneUrl] = [urlParams.get('number'), urlParams.get('phone')];

  const [track, setTrack] = useState(numberUrl || '');
  const [phone, setPhone] = useState(`+7${phoneUrl?.slice(-10)}` || '+7');
  const [errorTrack, setErrorTrack] = useState<string | null>(null);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [serverText, setServerText] = useState('');

  const [history, setHistory] = useState<ITracking>(StubTrackingInfo);
  const [dataInfo, setDataInfo] = useState<string[][]>([]);

  const [nameForm, setNameForm] = useState('');
  const [errorNameForm, setErrorNameForm] = useState<string | null>(null);
  const [phoneForm, setPhoneForm] = useState('+7');
  const [errorPhoneForm, setErrorPhoneForm] = useState<string | null>(null);
  const [msgForm, setMsgForm] = useState('');
  const [errorMsgForm, setErrorMsgForm] = useState<string | null>(null);
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtnTracking, setDisableBtnTracking] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  useEffect(() => {
    if (numberUrl && phoneUrl) {
      ServiceData.tracking({ track, phone, setServerText, setHistory, success: successTracking });
      window.location.hash = '';
      window.location.hash = '#result';
    }
  }, []);

  const Tracking = (e: any) => {
    e.preventDefault();
    setDisableBtnTracking(true);

    if (!ValidationFormTracking({ track, phone, setErrorTrack, setErrorPhone })) {
      setDisableBtnTracking(false);
      return;
    }

    window.location.hash = '';
    window.location.hash = '#result';

    ServiceData.tracking({ track, phone, setServerText, setHistory, success: successTracking });
  };

  const successTracking = () => {
    setDisableBtnTracking(false);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();
    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    if (!executeRecaptcha) {
      setDisableBtn(false);
      return;
    }

    const token = await executeRecaptcha(); // v3
    // const token = await recaptchaV2ref.current.executeAsync();

    if (
      !ValidationFormItems({
        fields: [msgForm],
        arrSetError: [setErrorMsgForm],
        phone: phoneForm,
        setErrorPhone: setErrorPhoneForm,
      })
    ) {
      setDisableBtn(false);
      return;
    }
    ServiceData.sendEmailContacts({
      data: {
        name: nameForm,
        phone: phoneForm,
        msg: msgForm,
        page: pageName,
        department: 0,
        orderNumber: '-',
      },
      token,
      success,
      setServerText,
      blockedSendLoaded,
      eventMetrika: 'form_tracking',
      contactFormId: contactForms.main_contact_form_id
    });
  };

  const success = () => {
    setNameForm('');
    setPhoneForm('+7');
    setMsgForm('');
    setSuccessShow(true);
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
  };

  const { statushistory, number, date, town, company, invoice } = history;
  useEffect(() => {
    setDataInfo([
      [
        `<h4>Служба доставки:</h4>`,
        `<p class='body2 table__text-start'>${GetDeliveryService(statushistory.status[0].office)}`,
      ],
      [`<h4>№ отправления:</h4>`, `<p class='body2 table__text-start'>${number}`],
      [`<h4>Дата заказа:</h4>`, `<p class='body2 table__text-start'>${date}`],
      [`<h4>Статус:</h4>`, `<p class='body2 table__text-start'>${statushistory.status[0].title}`],
      [`<h4>Город назначения:</h4>`, `<p class='body2 table__text-start'>${town}`],
    ]);
  }, [history]);

  return (
    <div className="page-tracking">

      <Content
        noLazy
        block={
          <form className="page-tracking__form" onSubmit={Tracking}>
            <Input
              label="Номер заказа"
              placeholder=""
              value={track}
              onChange={(e: any) => setTrack(e.target.value)}
              error={errorTrack}
              marginTop={20}
            />
            <InputPhone
              label="Телефон"
              value={phone}
              onChange={(e: any) => setPhone(e.target.value)}
              error={errorPhone}
            />
            <div className="page-tracking__button">
              {serverText && serverText !== NoFoundServerText ? ErrorText(serverText, true) : null}
              <Button text="Отследить" widthAll disabled={disableBtnTracking} />
            </div>
            <p className="page-tracking__agreement">
              {`Нажимая на кнопку Отследить, вы соглашаетесь с условиями предоставления услуг и `}
              <a href={EnumUrlsPages.policy}>политикой конфиденциальности</a>
            </p>
          </form>
        }
      />

      <AnchorSection id="result">
        <Content
          padding={{ paddingMain: { top: 80, bottom: 0 }, paddingMob: { top: 40, bottom: 0 } }}
          block={
            <>
              {number.toString().length ? (
                <div className="page-tracking__data">
                  <div className="page-tracking__info">
                    <h3>Общие данные</h3>
                    <Table
                      themeLight
                      perc50
                      data={dataInfo}
                      headLight={
                        <tr className="table__head-white">
                          {[`<h4>Отправитель:</h4>`, `<p class='body2 table__text-start'>${company}</p>`].map(
                            (item, i) => (
                              <td dangerouslySetInnerHTML={{ __html: item }} key={i}></td>
                            )
                          )}
                        </tr>
                      }
                    />
                    {invoice.length ? (
                      <Button text="Открыть чек" link={invoice} linkOut type="border" widthAll />
                    ) : null}
                  </div>

                  <div className="page-tracking__info">
                    <h3>История заказа</h3>
                    <div className="page-tracking__statuses">
                      {statushistory.status.map(({ eventtime, office, title }, i) => (
                        <div className="page-tracking__status" key={i}>
                          <p className="body2">{`${title} (${office})`}</p>
                          <p>{moment(new Date(eventtime)).format('DD.MM.YYYY, HH:mm')}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          }
        />
      </AnchorSection>

      {serverText === NoFoundServerText ? (
        <div className="page-tracking__no-found">
          <h3>Заказ с таким номером не найден</h3>
          <p className="body1">Пожалуйста, проверьте указанный вами номер заказа и номер телефона</p>
        </div>
      ) : null}

      {/* <Content
        block={
          <div className="page-tracking__form-contact">
            <FormContainer
              title="Есть вопросы по доставке? Пишите"
              subTitle=""
              phone
              buttonWidthAll
              disableBtn={disableBtn}
              showBlockedError={showBlockedError}
              form={
                <>
                  <div className="page-tracking__form-grid">
                    <Input
                      label="Имя"
                      name="name"
                      value={nameForm}
                      onChange={(e: any) => setNameForm(e.target.value)}
                      error={errorNameForm}
                      marginTop={0}
                    />
                    <InputPhone
                      label="Телефон*"
                      name="phone"
                      value={phoneForm}
                      onChange={(e: any) => setPhoneForm(e.target.value)}
                      error={errorPhoneForm}
                      marginTop={0}
                    />
                  </div>
                  <Textarea
                    label="Сообщение*"
                    value={msgForm}
                    onChange={(e: any) => setMsgForm(e.target.value)}
                    error={errorMsgForm}
                  />
                </>
              }
              onSubmit={handleReCaptchaVerify}
              serverText={serverText}
              successShow={successShow}
              heightSuccessForm="564px"
            />
          </div>
        }
      /> */}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageTracking));
